import { ModelBase } from 'store/model-base';

export class CmsAddonErrors extends ModelBase {
    public static storeName: string = 'cmsAddonErrors';

    public addPass: CmsAddonError;
    public removePass: CmsAddonError;
    public cancelRemovePass: CmsAddonError;
}
